import { makeHook } from "../../utils/makeSingleArgHook";
import getAdvisorClients, { url } from "../requests/getAdvisorClients";
export const keyMaker = () => [url()];
const useAdvisorClients = makeHook(async (isAdmin, auth) => getAdvisorClients(auth), keyMaker); //keeping isAdmin param so Expo doesn't break
export default useAdvisorClients;
//# sourceMappingURL=useAdvisorClients.js.map